import {Component, HostBinding, Input} from '@angular/core';
import {AuthorizationService} from '../../authorization/authorization.service';

@Component({
  selector: 'app-user-sim-balance-menu',
  templateUrl: './user-sim-balance-menu.component.html',
})
export class UserSimBalanceMenuComponent {
  @HostBinding('class.header-menu-item') userSimBalance = true;
  @Input() simBalance: { show: boolean, value: string, isAlarming: boolean };

  constructor(
    public authorizationService: AuthorizationService
  ) {
  }
}
